export default __webpack_public_path__ + "static/media/bell_icon.5f49037a.svg";